import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import HelpTip from './HelpTip';
const RuleOptions = ({ draft, update, disabled }) => (
  <div className="mb-3">
    <h5>Finish up</h5>
    <p className="small text-muted">
      Give the rule a name you will recognize, and decide whether later rules
      should still be checked.
    </p>
    <Form.Check
      id="rate-shop-rule-enabled"
      type="switch"
      label={
        <span>
          Rule is enabled{' '}
          <HelpTip label="Rule is enabled">
            Turn this off to keep the rule saved without using it on orders.
          </HelpTip>
        </span>
      }
      checked={draft.enabled !== false}
      disabled={disabled}
      onChange={e => update({ enabled: e.target.checked })}
      className="mb-3"
    />
    <Form.Check
      id="rate-shop-rule-stop"
      type="switch"
      label={
        <span>
          Stop checking other rules after this one matches{' '}
          <HelpTip label="Stop checking other rules">
            Later rules will not be checked for matching orders. Leave this off
            when other rules should add their instructions too. An early stop
            can bypass safety rules.
          </HelpTip>
        </span>
      }
      checked={Boolean(draft.stopProcessing)}
      disabled={disabled}
      onChange={e => update({ stopProcessing: e.target.checked })}
      className="mb-3"
    />
    <Form.Group controlId="rate-shop-rule-notes">
      <Form.Label>
        Notes{' '}
        <HelpTip label="Notes">
          Leave a reminder explaining why this rule is needed.
        </HelpTip>
      </Form.Label>
      <Form.Control
        as="textarea"
        rows={2}
        value={draft.notes || ''}
        disabled={disabled}
        onChange={e => update({ notes: e.target.value })}
        placeholder="Why do we need this rule?"
      />
    </Form.Group>
    <details className="mt-3">
      <summary className="small text-primary">Advanced: rule order</summary>
      <Row className="mt-2">
        <Col md={6}>
          <Form.Group controlId="rate-shop-rule-priority">
            <Form.Label>
              Check this rule at priority{' '}
              <HelpTip label="Rule priority">
                Lower numbers are checked first. You can also drag rules in the
                Rules list to change their order.
              </HelpTip>
            </Form.Label>
            <Form.Control
              type="number"
              step="any"
              value={draft.priority}
              disabled={disabled}
              onChange={e =>
                update({
                  priority: e.target.value === '' ? '' : Number(e.target.value)
                })
              }
            />
          </Form.Group>
        </Col>
      </Row>
    </details>
  </div>
);
export default RuleOptions;
